import styled from '@emotion/styled';
import { H3 } from 'ds/components/typography';


export const Header = styled(H3)<{ combinedFiltersSearchMode?: boolean }>`
  ${({ theme, combinedFiltersSearchMode }) => `
    color: ${theme.colors.neutrals.grey1};
    margin-bottom: ${theme.spacing(combinedFiltersSearchMode ? 2 : 3)};
    ${combinedFiltersSearchMode ? 'font-size: 15px;' : ''}
  `}
`;
